import * as axiosService from "../axiosService";

export const getVendorInvoiceDraftList = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/GetDraftList`,
    payload,
  );
};

export const getVendorInvoiceDraftDetail = (draftId) => {
  return axiosService.Get(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/GetDraftDetail?draftId=${draftId}`,
  );
};

export const getVendorSubmittedInvoiceList = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/GetInvoiceList`,
    payload,
  );
};

export const downloadVendorInvoice = (draftId) => {
  return axiosService.DownloadGet(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/DownloadVendorDraft?draftId=${draftId}`,
    {
      responseType: "blob",
    },
  );
};

export const getVendorInvoiceDetail = (invoiceId) => {
  return axiosService.Get(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/GetInvoiceDetail?invoiceId=${invoiceId}`,
  );
};

export const getOrderListInvoiceCreation = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/Order/GetOrderListForInvoiceGeneration`,
    payload,
  );
};

export const getInvoiceStatusList = () => {
  return axiosService.Get(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/GetStatusList`,
  );
};

export const saveVendorInvoice = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/SaveInvoice`,
    payload,
  );
};
export const saveVendorInvoiceDraft = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/SaveDraft`,
    payload,
  );
};

export const getOrderDetailsForInvoice = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/Order/GetOrderDetailsForInvoice`,
    payload,
  );
};

//get move type which has data
export const getTripMoveTypeForInvoicing = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/VendorInvoice/GetTripMoveTypeForInvoicing`,
    payload,
  );
};

export const getInvoiceOrderListFilterMasterData = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/Order/GetInvoiceOrderListFilterMasterData`,
    payload,
  );
};

export const getOrderListForInvoiceGeneration_V2 = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/Order/GetOrderListForInvoiceGeneration_V2`,
    payload,
  );
};

//get trip list
export const getInvoiceOrderTripList = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/Order/GetInvoiceOrderTripList`,
    payload,
  );
};

//upload pod doc
export const uploadPODDocumentForTrips = (payload) => {
  return axiosService.Post(
    `${process.env.REACT_APP_COMMON_AUTH_API_URL}/Order/UploadPODDocument`,
    payload,
  );
};
